import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { NbDialogRef } from "@nebular/theme";
import * as _ from "lodash";
import { Subject } from "rxjs";

import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";

@Component({
  selector: "ngx-dialog-sort-list",
  templateUrl: "dialog-sort-list.component.html",
  styleUrls: ["dialog-sort-list.component.scss"],
})
export class DialogSortListComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() list?: any[];

  submitted = false;
  loading = false;

  constructor(protected ref: NbDialogRef<DialogSortListComponent>) {}

  ngOnInit() {
    // console.log("DialogSortListComponent/ngOnInit:", this.list);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.list, event.previousIndex, event.currentIndex);

    // console.log("DialogSortListComponent/drop:", this.list);
  }

  cancel() {
    this.ref.close();
  }

  submit() {
    this.submitted = true;

    // console.log("DialogSortListComponent/submit:", this.list);
    this.ref.close(this.list);
  }
}
